import React, { useState } from "react";

import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import axios from "react-axios";

import { postUserApplication } from "~/api/getUser";
import { validate } from "./ApplyValidationRules";
import useTrackCommentForm from "../useTrackCommentForm";

import styled from "styled-components";

import "~/css/forms.less";

export const Wrapper = styled.section`
  margin: 60px 0 80px 0;
`;

const testData = {
  email_address: "dreamchimney+test2@gmail.com",
  chim_name: "Test2",
  real_name: "App Test2",
  location: "San Francisco, CA",
  current_totd: "Title and Artist",
  reason_to_be_chim: "Here is a good reason",
  top_ten: "Favorite Albums goes here",
  reason_what: "No one",
};

const Apply = ({ onComplete, onFailure }) => {
  const [loading, setLoading] = useState(false);
  const [agreed, setAgreed] = useState(false);

  const initialFormValues = {};

  // useEffect(() => {
  //   setLoading(!userState.loaded);
  // }, [userState.loaded]);

  const postApplication = async () => {
    setLoading(true);

    const payload = {
      ...inputs,
    };

    try {
      await postUserApplication(axios, payload);
      setLoading(false);
      onComplete();
    } catch (err) {
      setLoading(false);
      onFailure();
    }
  };

  const { inputs, handleInputChange, handleSubmit, errors } = useTrackCommentForm(initialFormValues, postApplication, validate);

  return (
    <Wrapper>
      <Form className="totd-form totd-form-horizontal apply-form" noValidate onSubmit={(e) => handleSubmit(e)}>
        <Row>
          <Col xs={12} md={6} className="profile-edit-left">
            {/* <p>Left Side</p> */}
            <Form.Group as={Row}>
              <Col md={10} className={errors.email_address ? "error" : ""}>
                <Form.Label>Your preferred email address:</Form.Label>
                <Form.Control
                  name="email_address"
                  onChange={handleInputChange}
                  value={inputs.email_address || ""}
                  type="email"
                  autoComplete="off"
                  required
                />
                {errors.email_address && <span className="help error">{errors.email_address}</span>}
              </Col>
              <Col md={10} className={errors.chim_name ? "error" : ""}>
                <Form.Label>Chimney Name:</Form.Label>
                <div>
                  <Form.Control
                    name="chim_name"
                    onChange={handleInputChange}
                    value={inputs.chim_name || ""}
                    type="text"
                    autoComplete="off"
                    required
                    className="w-50 chim-name"
                  />
                  Chimney
                </div>
                <Form.Text className="text-muted">Enter the Chimney name you would like to be referred to as</Form.Text>
                {errors.chim_name && <span className="help error">{errors.chim_name}</span>}
              </Col>
              <Col md={10} className={errors.real_name ? "error" : ""}>
                <Form.Label>Your Real Name:</Form.Label>
                <Form.Control
                  name="real_name"
                  onChange={handleInputChange}
                  value={inputs.real_name || ""}
                  type="text"
                  autoComplete="off"
                  required
                />
                <Form.Text className="text-muted">Not displayed on the site</Form.Text>
                {errors.real_name && <span className="help error">{errors.real_name}</span>}
              </Col>
              <Col md={10} className={errors.location ? "error" : ""}>
                <Form.Label>Your Location:</Form.Label>
                <Form.Control
                  name="location"
                  onChange={handleInputChange}
                  value={inputs.location || ""}
                  type="text"
                  autoComplete="off"
                  required
                />
                {errors.location && <span className="help error">{errors.location}</span>}
              </Col>
            </Form.Group>
          </Col>

          <Col xs={12} md={6} className="profile-edit-right">
            {/* Right Side */}

            <Form.Group as={Row} className={errors.current_totd ? "error" : ""}>
              <Col md={10}>
                <Form.Label>Your current Track of the Day (title and artist)</Form.Label>
                <Form.Control
                  name="current_totd"
                  onChange={handleInputChange}
                  value={inputs.current_totd || ""}
                  type="text"
                  autoComplete="off"
                />
                {errors.current_totd && <span className="help error">{errors.current_totd}</span>}
              </Col>
            </Form.Group>

            <Form.Group as={Row} className={errors.top_ten ? "error" : ""}>
              <Col md={10}>
                <Form.Label>Top 10 All Time Favorite Albums/Artists:</Form.Label>
                <Form.Control
                  disabled={loading}
                  name="top_ten"
                  onChange={handleInputChange}
                  value={inputs.top_ten || ""}
                  as="textarea"
                  rows="3"
                />
                {errors.top_ten && <span className="help error">{errors.top_ten}</span>}
              </Col>
            </Form.Group>

            <Form.Group as={Row} className={errors.reason_to_be_chim ? "error" : ""}>
              <Col md={10}>
                <Form.Label>Reason to become a Chimney:</Form.Label>
                <Form.Control
                  disabled={loading}
                  name="reason_to_be_chim"
                  onChange={handleInputChange}
                  value={inputs.reason_to_be_chim || ""}
                  as="textarea"
                  rows="3"
                />
                {errors.reason_to_be_chim && <span className="help error">{errors.reason_to_be_chim}</span>}
              </Col>
            </Form.Group>

            <Form.Group as={Row} className={errors.reason_what ? "error" : ""}>
              <Col md={10}>
                <Form.Label>What Chimney do you know (if any)?</Form.Label>
                <Form.Control
                  name="reason_what"
                  onChange={handleInputChange}
                  value={inputs.reason_what || ""}
                  type="text"
                  autoComplete="off"
                />
                {errors.reason_what && <span className="help error">{errors.reason_what}</span>}
              </Col>
            </Form.Group>

            <Form.Group as={Row} className={errors.agreed ? "error" : ""}>
              <Col md={10}>
                <Form.Label>As part of "Track of the Day", you must agree to post a track at least once a week.</Form.Label>
                <Form.Group className="mb-3 checkboxAgree" controlId="agreed">
                  <Form.Check
                    type="checkbox"
                    label="I agree or at least ill try"
                    required
                    checked={agreed}
                    onChange={() => setAgreed(!agreed)}
                  />
                </Form.Group>
              </Col>
            </Form.Group>

            <Col md={10}>
              <p>Click the button below to submit your application. We will carefully review your application and get back to you ASAP.</p>
              <Button disabled={loading} size="lg" variant="success" type="submit">
                Submit
              </Button>
              {/* <Button onClick={(e) => backButton(e)} disabled={loading} variant="cancel" type="cancel">
                Cancel
              </Button> */}
            </Col>
          </Col>
        </Row>
      </Form>
    </Wrapper>
  );
};

export default Apply;
